/**
 * Returns true when graph payload has the data required to render the ownership graph.
 */
export const hasValidShareholderGraph = (graph) => {
    if (!graph || typeof graph !== 'object') {
        return false;
    }

    if (!graph.from_cin) {
        return false;
    }

    if (!Array.isArray(graph.entities) || graph.entities.length === 0) {
        return false;
    }

    if (!Array.isArray(graph.relations) || graph.relations.length === 0) {
        return false;
    }

    return true;
};
